function PopupMenuMobile (element, options) {
  INKIVE.PopupMenuDefault.call(this, element, options);
}

PopupMenuMobile.prototype = Object.create(INKIVE.PopupMenuDefault.prototype);
PopupMenuMobile.prototype.constructor = PopupMenuMobile;

PopupMenuMobile.prototype.getWrapperHtml = function () {
  const isPortrait = false; // (window.innerHeight > window.innerWidth);

  return '<div class="menu popupmenu mobile ' + (isPortrait ? 'portrait' : 'landscape') + '" data-id="' + this.id + '" data-element-id="' + this.$element.attr('id') + '">' +
        '<div class="tool-static-block back-menu">' +
        '<a class="btn" data-href=""><div class="icon-element"><i class="icon-chevron-left"></i></div><span class="text-element">Back to Main menu</span></a>' +
        '</div>' +
        '<div class="undoredo">' +
        '<a class="btn btn-onmenu action" data-action="on_undo" id="ik-undo" type="toggle"><i class="icon-reply"></i><span class="ui-dropdown-title">undo</span></a>' +
        '<a class="btn btn-onmenu action" data-action="on_redo" id="ik-redo" type="toggle"><i class="icon-forward"></i><span class="ui-dropdown-title">redo</span></a>' +
        '</div>' +
        '</div>';
};

PopupMenuMobile.prototype.getSpacer = function () {
  return null;
};

PopupMenuMobile.prototype.getButtonWrapper = function () {
  return $.parseHTML('<li></li>');
};

PopupMenuMobile.prototype.refresh = function () {
  // ignore super
};

PopupMenuMobile.prototype.build = function () {
  INKIVE.PopupMenuDefault.prototype.build.call(this);

  const that = this;
  // Init back menu action
  that.wrapper().find('.back-menu a').click(function () {
    const tool = INKIVE.Tool.getInstance();
    tool.editor.canvas.clearSelection();
    tool.mobileBackMenuShow(false);
    that.destroy();
  });
};

export default PopupMenuMobile;
